import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from 'App'
import Redirect from 'components/Redirect'
import Blank from 'components/Blank'
import AuthLogin from 'components/auth/Login'
import reportWebVitals from './reportWebVitals'

import 'skin/index.sass'

const Main = () => {

  return <>main</>
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={ App }>
          <Route path="main" Component={ Main } />

          <Route
            index
            element={ <Redirect to="/main" /> }
          />

          <Route
            path="*"
            element={ <Redirect to="/main" /> }
          />
        </Route>

        <Route path="auth" Component={ Blank }>
          <Route path="login" Component={ AuthLogin } />

          <Route
            index
            element={ <Redirect to="/auth/login" /> }
          />

          <Route
            path="*"
            element={ <Redirect to="/auth/login" /> }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
